module.exports = __webpack_public_path__ + "img/181.9dfa1b24.jpg";